/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  list: {},
  trialPeriod: {},
  error: null,
  loading: false,
  loaded: true,
  pendingUserNotificaiton: null,
  trialNotification: null,
  dismissed: [],
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.DISMISS_NOTIFICATION: {
      localStorage.setItem(
        "dismissedNots",
        JSON.stringify([...state.dismissed, action.payload]),
      );
      return {
        ...state,
        dismissed: [...state.dismissed, action.payload],
      };
    }
    case types.RESET_DISMISS_NOTIFICATION: {
      const nots = localStorage.getItem("dismissedNots");
      // if (nots) {
      return nots
        ? {
            ...state,
            dismissed: JSON.parse(nots),
          }
        : state;
      // } else {
      //   return state;
      // }
    }
    case types.CLEAR_DISMISS_NOTIFICATION: {
      localStorage.removeItem("dismissedNots");
      return {
        ...state,
        dismissed: [],
        pendingUserNotificaiton: null,
        trialNotification: null,
      };
    }
    case types.FETCH_PENDING_USER_NOTIF: {
      return {
        ...state,
        loading: true,
        loaded: false,
        pendingUserNotificaiton: null,
      };
    }
    case types.FETCH_PENDING_USER_NOTIF_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        pendingUserNotificaiton: action.payload,
      };
    }
    case types.FETCH_PENDING_USER_NOTIF_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        pendingUserFetchError: action.payload,
      };
    }
    case types.FETCH_TRIAL_PERIOD_NOTIF: {
      return {
        ...state,
        loading: true,
        loaded: false,
        trialFetchError: null,
        trialNotification: null,
      };
    }
    case types.FETCH_TRIAL_PERIOD_NOTIF_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        trialFetchError: null,
        trialNotification: action.payload,
      };
    }
    case types.FETCH_TRIAL_PERIOD_NOTIF_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        trialFetchError: action.payload,
      };
    }
    default:
      return state;
  }
}
